import React from 'react';
import { observer } from 'mobx-react';
import { withNamespaces } from 'react-i18next';

import { Field } from 'libs/forms/views/field';
import RadioGroup from 'components/Form/RadioGroup';

@withNamespaces()
@observer
export class RadioGroupAdapter extends Field {
  render() {
    const { t } = this.props;
    const {
      checkedOptionIndex,
      label: groupLabel,
      groupName,
    } = this.props.fieldStore.conf;
    const { options } = this.props.fieldStore.optionsManager;
    // CHECKME - this shouldn't be applied over user provided data
    const translatedOptions = options?.map(
      ({ label, labelSecondary, ...optionRest }) => {
        const translatedLabel = label && t(label);
        const translatedSecondaryLabel = labelSecondary && t(labelSecondary);
        return {
          label: translatedLabel,
          labelSecondary: translatedSecondaryLabel,
          ...optionRest,
        };
      },
    );
    return (
      <RadioGroup
        selectedItemId={this.props.fieldStore.value}
        items={translatedOptions}
        groupLabel={groupLabel && t(groupLabel)}
        groupName={groupName}
        checkedOptionIndex={checkedOptionIndex}
        onOptionChecked={(item, event) => this.updateValue(event.nativeEvent)}
      />
    );
  }
}
